export default "__VITE_ASSET__BbB2vd1E__"